const openPopup = (url: string, title: string, popupW = 626, popupH = 436) => {
	const winTop = screen.height / 2 - popupH / 2;
	const winLeft = screen.width / 2 - popupW / 2;

	window.open(
		url,
		title,
		`left=${winLeft},top=${
			winTop / 2
		},height=${popupH},width=${popupW},resizable=1,toolbar=no`,
	);
};

export const facebook = (url = window.location.href) => {
	openPopup(
		`http://www.facebook.com/sharer.php?u=${encodeURIComponent(url)}`,
		"Facebook",
	);
};

export const pinterest = (
	media: string,
	description = "",
	url = window.location.href,
) => {
	openPopup(
		`//www.pinterest.com/pin/create/button/?url=${url}&media=${media}&description=${description}`,
		"Pinterest",
	);
};

export const copy = async (url?: string) => {
	try {
		const locationUrl = window.location.href.toString();
		await navigator.clipboard.writeText(url ?? locationUrl);
	} catch {
		console.info(`Couldn't copy to clipboard`);
	}
};
